export const PRODUCTS_API = '/api/products';
export const ORDERS_API = '/api/orders';
export const SETTINGS_API = '/api/settings';
export const SEND_EMAIL_API = '/api/SendOrderEmailFunction';
export const ANALYTICS_API = '/api/analytics';

export const GET_GENERAL_DATA_FUNCTION = '/api/GetGeneralDataFunction';
export const UPDATE_GENERAL_INFO_FUNCTION = '/api/UpdateGeneralInfo'; //
export const GET_COLORS_FUNCTION = '/api/colors';
export const UPDATE_COLORS_FUNCTION = '/api/colors';
export const DELIVERY_OPTIONS_FUNCTION = `${SETTINGS_API}/delivery/options`;